module.exports = __webpack_public_path__ + "img/04d3cdb.svg";